import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../pages/home/index.vue')
  },
  {
    path: '/gohome',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../pages/home/index.vue')
  },
  {
    path: '/aboutus',
    name: 'Aboutus',
    component: () => import('../pages/aboutus/index.vue')
  },
  // {
  //   path: '/detail',
  //   name: 'Detail',
  //   component: () => import('../pages/notfound/index.vue')
  // },
  {
    path: '/miaosha',
    name: 'Miaosha',
    component: () => import('../pages/miaosha/index.vue')
  },
  {
    path: '/hotsale2h',
    name: 'Hotsale2h',
    component: () => import('../pages/hotsale2h/index.vue')
  },
  {
    path: '*',
    name: '',
    component: () => import('../pages/notfound/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
